import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"

const AOI検査 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { aoiInspection: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField
      isShow={shouldShow}
      legend={"AOI検査\n（外観光学検査）"}
      helpURL={HELP_LINKS["AOI検査（外観光学検査）"]}
    >
      <RadioGroup
        name={FIELD_NAMES["AOI検査（外観光学検査）"]}
        selectedValue={values.aoiInspection}
        onChange={handlers.radio}
      >
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT["AOI検査（外観光学検査）"].あり.value}>あり</Radio>
          <Radio value={ESTIMATE_CONSTANT["AOI検査（外観光学検査）"].なし.value}>なし</Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.aoiInspection} />
    </OneClickField>
  )
}

export default AOI検査
